// extracted by mini-css-extract-plugin
export default {"searchbar":"searchbar_searchbar__exj6L"};